import moment from 'moment/moment';
import React, { useEffect, useState } from 'react';
import { BQLink } from '../../../../atoms/bqlink';
import { widgetLink } from '../../../../../helpers/utils';
import { CalendarTodayOutlineIcon, OpenInNewIcon } from '../../../../atoms/material-icons';
import EmptyState from '../empty-state';
import './calendar-events.m.css';

const CalendarEvents = ({ widget = false, container = '', customClass = '' }) => {
  const widgetParam = widget ? '?view=apps' : '';
  const [, setCalendareventsData] = useState({});
  const [dateKeys, setDateKeys] = useState('');
  const [filteredOriginalData, setFilteredOriginalData] = useState(null);
  const [tableData, setTableData] = useState({});
  const [boardMeeting, setBoardMeeting] = useState(false);
  const [dividend, setDividend] = useState(false);
  const [stockSplit, setStockSplit] = useState(false);
  const [bonusIssue, setBonusIssue] = useState(false);
  const [rightsIssue, setRightsIssue] = useState(false);
  const [toggle, setToggle] = useState(-1);
  const [initialLoading, setInitialLoading] = useState(true);
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const getCalendarEventsData = async () => {
      const response = await fetch('/feapi/markets/calendar-events/indices/events');
      const data = await response.json();
      const requiredDateArray = [];
      for (let i = 0; i < 7; i++) {
        requiredDateArray.push(moment(Date.now() - i * 24 * 3600 * 1000).format('YYYY-MM-DD'));
      }

      for (let i = 0; i < 4; i++) {
        requiredDateArray.push(moment(Date.now() + i * 24 * 3600 * 1000).format('YYYY-MM-DD'));
      }

      const filteredData = Object.keys(data?.data)
        .reverse()
        .filter((key) => requiredDateArray.includes(key))
        .reduce((obj, key) => {
          obj[key] = data?.data[key];
          return obj;
        }, {});
      setCalendareventsData(data);
      setDateKeys(Object.keys(filteredData));
      setFilteredOriginalData(filteredData);
      setTableData(filteredData[requiredDateArray[0]]);
      setBoardMeeting(true);
      setDividend(false);
      setStockSplit(false);
      setBonusIssue(false);
      setRightsIssue(false);
      setToggle(3);
    };

    getCalendarEventsData();
  }, []);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    setIsDarkMode(mediaQuery.matches);

    const handleChange = (e) => setIsDarkMode(e.matches);
    mediaQuery.addEventListener('change', handleChange);

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  const dateButtonHandler = (val, index) => {
    const filtered = Object.keys(filteredOriginalData)
      .filter((key) => key === val)
      .reduce((obj, key) => {
        return {
          ...obj,
          [key]: filteredOriginalData[key],
        };
      }, {});

    setTableData(filtered[val]);
    setToggle(index);
  };

  const boardMeetingHandler = () => {
    setBoardMeeting(true);
    setDividend(false);
    setStockSplit(false);
    setBonusIssue(false);
    setRightsIssue(false);
  };

  const dividendHandler = () => {
    setBoardMeeting(false);
    setDividend(true);
    setStockSplit(false);
    setBonusIssue(false);
    setRightsIssue(false);
  };

  const stockSplitHandler = () => {
    setBoardMeeting(false);
    setDividend(false);
    setStockSplit(true);
    setBonusIssue(false);
    setRightsIssue(false);
  };

  const bonusIssueHandler = () => {
    setBoardMeeting(false);
    setDividend(false);
    setStockSplit(false);
    setBonusIssue(true);
    setRightsIssue(false);
  };

  const rightsIssuesHandler = () => {
    setBoardMeeting(false);
    setDividend(false);
    setStockSplit(false);
    setBonusIssue(false);
    setRightsIssue(true);
  };

  if (initialLoading) {
    return <div styleName="initial-loading-container"></div>;
  }

  return (
    <div styleName={`calendar-events-container ${widget ? 'widget' : ''}`}>
      <div styleName="header-title-container">
        <CalendarTodayOutlineIcon size={'26px'} color={'#d01e51'} />
        <h4 styleName="list-header-title">CALENDAR EVENTS</h4>
      </div>
      {!dateKeys ? (
        <div styleName="no-data-container-ext">
          <div styleName="no-data-container-int">
            <EmptyState width={'190px'} height={'190px'} />
          </div>
        </div>
      ) : (
        <div styleName="content-grid">
          <div styleName="date-grid">
            {dateKeys &&
              dateKeys.slice(0, 6).map((date, index) => {
                var requiredDateFormat = moment(date, 'YYYY/MM/DD');
                var month = requiredDateFormat.format('MMM');
                var monthForReference = requiredDateFormat.format('MM');
                var day = requiredDateFormat.format('DD');
                var year = requiredDateFormat.format('YYYY');

                return (
                  <button
                    key={index}
                    styleName={`date-element ${index === toggle ? 'selected-filter' : ''}`}
                    onClick={() => {
                      dateButtonHandler(`${year}-${monthForReference}-${day}`, index);
                    }}
                  >
                    <p styleName={`day ${index === toggle ? 'selected-day' : ''}`}>{day}</p>
                    <p styleName="month">{month}</p>
                  </button>
                );
              })}
          </div>
          <div styleName="filter-table-grid">
            <div styleName="filter-container">
              <button
                styleName={`filter-btn ${boardMeeting ? 'selected-filter' : ''}`}
                onClick={boardMeetingHandler}
              >
                Board Meeting{' '}
                <span styleName="data-length">({tableData?.[0]?.data.length || 0})</span>
              </button>
              <button
                styleName={`filter-btn ${dividend ? 'selected-filter' : ''}`}
                onClick={dividendHandler}
              >
                Dividend <span styleName="data-length">({tableData?.[1]?.data.length || 0})</span>
              </button>
              <button
                styleName={`filter-btn ${stockSplit ? 'selected-filter' : ''}`}
                onClick={stockSplitHandler}
              >
                Stock Split{' '}
                <span styleName="data-length">({tableData?.[2]?.data.length || 0})</span>
              </button>
              <button
                styleName={`filter-btn ${bonusIssue ? 'selected-filter' : ''}`}
                onClick={bonusIssueHandler}
              >
                Bonus Issue{' '}
                <span styleName="data-length">({tableData?.[3]?.data.length || 0})</span>
              </button>
              <button
                styleName={`filter-btn ${rightsIssue ? 'selected-filter' : ''}`}
                onClick={rightsIssuesHandler}
              >
                Rights Issues{' '}
                <span styleName="data-length">({tableData?.[4]?.data.length || 0})</span>
              </button>
            </div>
            <div styleName={`table-container ${customClass}`}>
              {boardMeeting && (
                <table>
                  <thead styleName="table-header">
                    <tr>
                      <th styleName="table-header">#</th>
                      <th styleName="table-header">Company Name</th>
                      <th styleName="table-header">Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData?.[0]?.data.length > 0 ? (
                      tableData?.[0]?.data?.map((value, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{value?.name}</td>
                          <td>{value?.date}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" styleName="no-data">
                          No Board Meeting Announcement
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
              {dividend && (
                <table>
                  <thead styleName="table-header">
                    <tr>
                      <th styleName="table-header">#</th>
                      <th styleName="table-header">Company Name</th>
                      <th styleName="table-header">Expiry date</th>
                      <th styleName="table-header">Dividend</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData?.[1]?.data.length > 0 ? (
                      tableData?.[1]?.data?.map((value, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{value?.name}</td>
                          <td>{value['expiry-date']}</td>
                          <td>{value['dividend-percent']}%</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" styleName="no-data">
                          No Dividend Announcement
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
              {stockSplit && (
                <table>
                  <thead styleName="table-header">
                    <tr>
                      <th styleName="table-header">#</th>
                      <th styleName="table-header">Company Name</th>
                      <th styleName="table-header">Expiry date</th>
                      <th styleName="table-header">Ratio</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData[2]?.data.length > 0 ? (
                      tableData[2]?.data?.map((value, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{value?.name}</td>
                          <td>{value['expiry-date']}</td>
                          <td>{value.ratio}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" styleName="no-data">
                          No Stock Split Announcement
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
              {bonusIssue && (
                <table>
                  <thead styleName="table-header">
                    <tr>
                      <th styleName="table-header">#</th>
                      <th styleName="table-header">Company Name</th>
                      <th styleName="table-header">Expiry date</th>
                      <th styleName="table-header">Ratio</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData[3]?.data.length > 0 ? (
                      tableData[3]?.data?.map((value, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{value?.name}</td>
                          <td>{value['expiry-date']}</td>
                          <td>{value.ratio}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" styleName="no-data">
                          No Bonus Issue Announcement
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
              {rightsIssue && (
                <table>
                  <thead styleName="table-header">
                    <tr>
                      <th styleName="table-header">#</th>
                      <th styleName="table-header">Company Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData[4]?.data.length > 0 ? (
                      tableData[4]?.data?.map((value, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{value?.name}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="2" styleName="no-data">
                          No Rights Issue Announcement
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      )}
      {(!widget || (widget && container === 'full')) && (
        <BQLink
          styleName="detailed-calendar-btn"
          href={widgetLink(`/markets/equities/calendar-events${widgetParam}`, widget)}
          target="_blank"
          rel="noreferrer"
        >
          Detailed Calendar View{' '}
          <OpenInNewIcon
            color={isDarkMode && widget ? '#FFFFFF' : '#2b2b2b'}
            styleName="tab-icon"
          />
        </BQLink>
      )}
    </div>
  );
};

export default CalendarEvents;
